import type { ReactNode } from 'react'
import { OutlineButton } from './OutlineButton'

interface StatusMessageProps {
  children: ReactNode
  action?: { label: string; onClick: () => void }
}

export function StatusMessage({ children, action }: StatusMessageProps) {
  return (
    <div className="flex min-h-60 flex-col items-center justify-center gap-4 px-6 text-center">
      <p className="text-ink-muted text-balance">{children}</p>
      {action && <OutlineButton onClick={action.onClick}>{action.label}</OutlineButton>}
    </div>
  )
}
